<div class="px-3 py-3">
    <div class="row justify-content-center">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 self-align-center">
      <div>
        <h3 class="form-title">{{'pages.placeholders.CreateANewRetailerPricelist' | translate }}</h3>
        <form [formGroup]="createBatchForm" (ngSubmit)="onSubmit()">
          <div class="row g-0 my-4">
            <div
                class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
              >
                <div class="row g-0">
                  <div class="col-5 me-3">
                    <div class="form-item-input">
                      <mat-form-field class="w-100" appearance="outline">
                        <input
                          matInput
                          [matDatepicker]="picker"
                          formControlName="fromDate"
                          placeholder="{{'pages.Creditlinereport.From' | translate }}"
                          required
                        />
                        <mat-datepicker-toggle matSuffix [for]="picker">
                          <mat-icon matDatepickerToggleIcon
                            >keyboard_arrow_down</mat-icon
                          >
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-item-input">
                      <mat-form-field class="w-100" appearance="outline">
                        <input
                          matInput
                          [matDatepicker]="picker1"
                          formControlName="toDate"
                          placeholder="{{'pages.Creditlinereport.To' | translate }}"
                          required
                        />
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                          <mat-icon matDatepickerToggleIcon
                            >keyboard_arrow_down</mat-icon
                          >
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          
          <div class="form-footer mt-6">
            <ul class="list-inline text-center">
              <li class="list-inline-item">
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  class="rounded-0"
                >
                  <span translate class="translate">Create</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  class="rounded-0"
                  (click)="onCancel()"
                >
                  <span translate class="translate">pages.newRetailer.cancel</span>
                </button>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
  